import React, { useRef } from 'react';
import {
  ListBase,
  ListToolbar,
  Pagination,
  useRefresh,
  Title,
  Datagrid,
  TextField,
  SelectField,
} from 'react-admin';

import { Card, makeStyles } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import VisibilityIcon from '@material-ui/icons/Visibility';

import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { formatPorcentagem } from '../../utils';
import {
  TIPO_ALIQUOTA_IBS_CBS_FIXA,
  TIPO_ALIQUOTA_IBS_CBS_PADRAO,
  TIPO_ALIQUOTA_IBS_CBS_SEM_ALIQUOTA,
  TIPO_ALIQUOTA_IBS_CBS_UNIFORME_NACIONAL,
  TIPO_ALIQUOTA_IBS_CBS_UNIFORME_SETORIAL,
  SECONDARY_COLOR,
  STATUS_ATIVO,
} from '../../utils/constants';
import { PERMISSAO_TELA_TABELA_CCLASSTRIB_LISTAR } from '../../utils/dadosTelas';
import StatusField from '../TabelaCstIbsCbs/StatusField';
//import ActionsField from './ActionsField';
import ActionsList from './ActionsList';
import DialogoImportarXCSVIBTP from './DialogoImportarXCSVIBTP';
import DialogoShow from './DialogoShow';
import DialogoStatus from './DialogoStatus';
import Filter from './Filter';

const useStyles = makeStyles((theme) => ({
  dataHeader: {
    flex: 1,
    backgroundColor: SECONDARY_COLOR,
    padding: '10px',
    color: 'white',
    fontWeight: 'bold',
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
  dataCell: {
    flex: 1,
    padding: '10px',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
}));

function ParagradoImposto({ label, valor }) {
  return (
    <p>
      <span
        style={{
          fontWeight: 'bold',
          marginRight: '5px',
        }}
      >
        {label}:
      </span>
      <span>{valor} </span>
    </p>
  );
}

const Panel = (props) => (
  <div>
    <ParagradoImposto label="CST" valor={props.record.cst} />
    <ParagradoImposto label="Código" valor={props.record.c_class_trib} />
    <ParagradoImposto label="Nome" valor={props.record.nome} />
    <ParagradoImposto label="Descrição" valor={props.record.descricao} />
    <ParagradoImposto
      label="pRedIBS"
      valor={formatPorcentagem(props.record.pRedIBS)}
    />
    <ParagradoImposto
      label="pRedCBS"
      valor={formatPorcentagem(props.record.pRedCBS)}
    />
  </div>
);

const choices = [
  { id: TIPO_ALIQUOTA_IBS_CBS_PADRAO, name: 'Padrão' },
  { id: TIPO_ALIQUOTA_IBS_CBS_UNIFORME_SETORIAL, name: 'Uniforme Setorial' },
  { id: TIPO_ALIQUOTA_IBS_CBS_UNIFORME_NACIONAL, name: 'Uniforme Nacional' },
  { id: TIPO_ALIQUOTA_IBS_CBS_FIXA, name: 'Fixa' },
  { id: TIPO_ALIQUOTA_IBS_CBS_SEM_ALIQUOTA, name: 'Sem Alíquota' },
];
//
const MyList = ({ ...props }) => {
  const classes = useStyles();
  const refresh = useRefresh();
  const refDialogoImportarXCSVIBTP = useRef(null);
  const refDialogoShow = useRef(null);
  const refDialogoStatus = useRef(null);

  function handleTabelaIbtp() {
    if (refDialogoImportarXCSVIBTP.current) {
      refDialogoImportarXCSVIBTP.current.handleOpen();
    }
  }

  function handleShow({ id }) {
    if (refDialogoShow.current) {
      refDialogoShow.current.handleOpen(id);
    }
  }

  function handleStatus({ id }) {
    if (refDialogoStatus.current) {
      refDialogoStatus.current.handleOpen(id);
    }
  }

  return (
    <>
      <Title title="Tabela ClassTrib" />
      <ListToolbar
        filters={props.filters}
        actions={
          <ActionsList handleImportarCsv={handleTabelaIbtp} {...props} />
        }
        {...props}
      />
      <Card style={{ borderRadius: '20px' }} {...props}>
        <Datagrid {...props}>
          <StatusField
            source="status"
            label="Status"
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
          />
          <TextField
            source="c_class_trib"
            label="Código"
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
          />
          <SelectField
            sortable={false}
            source="tipo_aliquota"
            label="Tipo de Alíquota"
            choices={choices}
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
          />
          <ActionsField
            source="lalala"
            textAlign="right"
            label="Ações"
            sortable={false}
            //handleShow={handleShow}
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
            //handleStatus={handleStatus}
            actions={[
              {
                title: 'Detalhes',
                icon: <VisibilityIcon />,
                onClick: (record) => handleShow(record),
              },
              {
                title: (record) =>
                  record.status === STATUS_ATIVO
                    ? 'Marcar como inativo'
                    : 'Marcar como ativo',
                icon: ({ record }) =>
                  record.status === STATUS_ATIVO ? (
                    <CancelIcon />
                  ) : (
                    <CheckCircleOutlineIcon />
                  ),
                onClick: (record) => handleStatus(record),
              },
            ]}
          />
        </Datagrid>
        <TransacoesPagination />
      </Card>
      <DialogoImportarXCSVIBTP
        ref={refDialogoImportarXCSVIBTP}
        handleClose={() => {}}
      />
      <DialogoShow
        ref={refDialogoShow}
        handleClose={() => {
          refresh();
        }}
      />
      <DialogoStatus
        ref={refDialogoStatus}
        handleClose={() => {
          refresh();
        }}
      />
    </>
  );
};

const ContainerMyList = ({ children, ...props }) => (
  <>
    <ListBase {...props}>
      <MyList {...props} />
    </ListBase>
  </>
);

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const List2 = (props) => (
  <ProtegerPagina permissao={PERMISSAO_TELA_TABELA_CCLASSTRIB_LISTAR}>
    <ContainerMyList
      {...props}
      expand={<Panel />}
      bulkActionButtons={false}
      pagination={<TransacoesPagination />}
      perPage={50}
      filters={<Filter />}
      title="Tabela CClassTrib"
      component="div"
    />
  </ProtegerPagina>
);

export default List2;
